export const isOtherSessionPresence = (notification, currentSessionId) =>
  notification?.eventType === 'hiPresence' &&
  notification.viewer != null &&
  notification.viewer.sessionId !== currentSessionId

export const summarizeViewers = (viewers = []) => {
  // viewers may contain multiple sessions of the same user (same id) — collapse to one per user
  // (the most recently seen), so a teammate with two tabs still shows as a single avatar.
  const latestPerUser = new Map()
  viewers.forEach(viewer => {
    const existing = latestPerUser.get(viewer.id)
    if (!existing || viewer.lastSeen > existing.lastSeen) {
      latestPerUser.set(viewer.id, viewer)
    }
  })

  const sorted = [...latestPerUser.values()].sort((a, b) => b.lastSeen - a.lastSeen)
  const primary = sorted[0] || null
  const overflowCount = Math.max(0, sorted.length - 1)
  let tooltip = ''
  if (primary) {
    tooltip =
      overflowCount > 0
        ? `${primary.name} and +${overflowCount} have this patient open`
        : `${primary.name} has this patient open`
  }
  return { primary, overflowCount, tooltip }
}
